import { isEqual } from "lodash";

export const generateFeatureName = (
  featureName: string,
  featureDescription?: string,
) => {
  const lastSpaceIndex = featureName.trim().lastIndexOf(" ");

  if (isEqual(lastSpaceIndex, -1) || !featureDescription) {
    return {
      first: featureName,
      last: "",
    };
  }

  return {
    first: featureName.slice(0, lastSpaceIndex + 1),
    last: featureName.slice(lastSpaceIndex),
  };
};

export const toSentence = (str?: string | null): string => {
  if (!str) return "";

  return str
    .replace(/([A-Z])/g, " $1")
    .trim()
    .replace(/^(\w+)(.*)/, (_, first, rest) => first + rest.toLowerCase());
};
